import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from './../../components/Footer';

const HisseBasinaKazanc = () => {
  const title = "Hisse Başına Kazanç: EPS Nedir ve Nasıl Hesaplanır? | Smart Finans";
  const description = "Hisse başına kazanç (EPS) nedir ve nasıl hesaplanır? Bu makalede, EPS'nin yatırım kararlarındaki önemi ve finansal analizde nasıl kullanıldığını keşfedin.";
  const canonicalUrl = "https://smart-portfoy.com/egitim/hisse-basina-kazanc"; // Replace with your actual URL

  const sections = [
    {
      title: 'Hisse Başına Kazanç (EPS) Nedir?',
      description: 'Hisse başına kazanç (EPS), bir şirketin net karının, hisse senedi sayısına bölünmesiyle elde edilen bir finansal göstergedir. EPS, yatırımcılar için şirketin karlılığını ve performansını değerlendirmede önemli bir metriktir.'
    },
    {
      title: 'EPS Nasıl Hesaplanır?',
      description: 'EPS hesaplaması, net karın toplam hisse senedi sayısına bölünmesiyle yapılır. Formül şu şekildedir:',
      points: [
        'EPS = Net Kar / Hisse Senedi Sayısı'
      ]
    },
    {
      title: 'EPS’nin Yatırımcılar İçin Önemi',
      description: 'EPS, yatırımcılar için şirketin karlılığını ve büyüme potansiyelini değerlendirmede önemli bir rol oynar. Yüksek EPS, genellikle şirketin iyi performans gösterdiğini ve yatırımcılar için cazip olduğunu gösterir.'
    },
    {
      title: 'EPS’nin Kullanım Alanları',
      description: 'EPS, yatırımcılar tarafından çeşitli şekillerde kullanılır:',
      points: [
        'Şirketin karlılığını değerlendirmek',
        'Fiyat/Kazanç (P/E) oranını hesaplamak',
        'Şirketler arası karşılaştırma yapmak'
      ]
    },
    {
      title: 'EPS ve P/E Oranı',
      description: 'EPS, P/E oranının hesaplanmasında kullanılır. P/E oranı, hisse senedinin fiyatının, hisse başına kazanca bölünmesiyle elde edilir. Bu oran, yatırımcıların bir hisse senedinin değerini değerlendirmelerine yardımcı olur.'
    },
    {
      title: 'Smart Portfoy ile Finansal Analiz',
      description: 'Smart Portfoy ile EPS ve diğer finansal göstergeleri kolayca analiz edin, otomatik raporlar oluşturun ve yatırım fırsatlarını daha iyi değerlendirin.'
    }
  ];

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={canonicalUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
        <meta name="keywords" content="hisse başına kazanç, EPS, yatırım, finansal analiz, karlılık" />
      </Helmet>

      <div className="min-h-screen bg-gray-800 text-gray-100">
        {/* Hero Section */}
        <header className="bg-gradient-to-r from-blue-900 to-indigo-900 py-16">
          <div className="container mx-auto px-4 max-w-6xl">
            <h1 className="text-4xl font-bold mb-4 mt-8 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-400">
              {title}
            </h1>
            <p className="text-lg text-gray-300 max-w-3xl leading-relaxed">
              {description}
            </p>
          </div>
        </header>

        {/* Image Section with Gradient Overlay */}
        <div className="relative h-48">
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 to-gray-900 z-10"></div>
          <img 
            src="/images/blog/eps/eps-guide.png" 
            alt="Hisse Başına Kazanç İllüstrasyonu"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content Section */}
        <div className="container mx-auto px-4 max-w-6xl py-8">
          <div className="space-y-8">
            {sections.map((section, index) => (
              <section key={index} className="space-y-4">
                <h2 className="text-2xl font-bold mb-4 text-blue-400 no-underline">
                  {section.title}
                </h2>
                {section.description && (
                  <p className="text-gray-300 text-base">{section.description}</p>
                )}
                {section.points && (
                  <ul className="space-y-2">
                    {section.points.map((point, pIndex) => (
                      <li key={pIndex} className="flex items-start space-x-2">
                        <span className="flex-shrink-0 w-6 h-6 bg-indigo-500 rounded-full flex items-center justify-center text-gray-900 font-bold">
                          {pIndex + 1}
                        </span>
                        <span className="text-gray-300">{point}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default HisseBasinaKazanc;